import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import type { QueryClient } from "@tanstack/react-query";

const MAX_AGE = 24 * 60 * 60 * 1000; // 24 hours

/**
 * Persists ONLY the aggregated dashboard payload (`["dashboard", ...]`) to
 * localStorage so a reload renders the page instantly and revalidates in the
 * background. Deliberately scoped: full transaction/balance lists never touch
 * localStorage. The persister is wired in main.tsx so tests (which build their
 * own QueryClients) never interact with browser storage.
 */
export function persistDashboardQueryCache(queryClient: QueryClient): void {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: "contablix-rq-dashboard",
  });

  void persistQueryClient({
    queryClient,
    persister,
    maxAge: MAX_AGE,
    dehydrateOptions: {
      shouldDehydrateQuery: query => query.queryKey[0] === "dashboard",
    },
  });
}
